module.exports = __webpack_public_path__ + "media/registry_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry_1600.jpg
// module id = 33
// module chunks = 0